import { RecruitScheduleData } from 'src/components/adminRecruit/useLoadRecruitSchedule';
import { create } from 'zustand';

interface AdScheduleState{
    recruitScheduleData : RecruitScheduleData[]
    type : string,
    status : string,
    sort_by : string,
    sort_order :string,
    page :number,
    pageSize : number,
    totalPage : number
    currnetdate: Date|string|undefined
    setField : (field: keyof AdScheduleState, value: any) => void 
    reset : ()=>void
}

const defaultValue = {
    type : '',
    status: '',
    recruitScheduleData: [],
    sort_by : 'created_at',
    sort_order :'desc',
    page :1,
    pageSize : 8,
    totalPage : 0,
    currnetdate : undefined
}

export const useAdRecruitStore = create<AdScheduleState>((set)=>({
    ...defaultValue,
    setField : (field,value)=>set((state)=>({...state,[field]:value})),
    reset : ()=>set({...defaultValue})
}))